{
  "allApps": "コンプリートプラン",
  "back": "メインに戻る",
  "myApps": "マイアプリ",
  "viewMoreApps": "表示関連アプリ"
}
